import { useMemo } from "react";
import { isAfter, parse } from "date-fns";

export const useGroupedTimeSlots = (data, options = { withoutReserved: false }) => {
	const { withoutReserved } = options;

	return useMemo(() => {
		if (!data) return undefined;

		return data.reduce((acc, item) => {
			if (!acc[item.weekday]) {
				acc[item.weekday] = { times: [], from: "23:00", to: "00:00" };
			}

			if (!acc[item.weekday].times.includes(item.time)) {
				if (withoutReserved) {
					acc[item.weekday].times.push(item.time);
				} else {
					acc[item.weekday].times.push({ value: item.time, reserved: item.reserved });
				}
			}

			const formatString = "HH:mm";
			const referenceDate = new Date();

			const current = parse(item.time, formatString, referenceDate);
			const from = parse(acc[item.weekday].from, formatString, referenceDate);
			const to = parse(acc[item.weekday].to, formatString, referenceDate);

			if (isAfter(from, current)) {
				acc[item.weekday].from = item.time;
			}
			if (isAfter(current, to)) {
				acc[item.weekday].to = item.time;
			}

			acc[item.weekday].times.sort();

			return acc;
		}, {});
	}, [data, withoutReserved]);
};
